import styled from 'styled-components';
import { GlobalFloatingPillWrapperProps } from '../types/GlobalFloatingPill.types';

export const GlobalFloatingPillWrapper = styled.span<GlobalFloatingPillWrapperProps>`
  [class*='Button-sc'] {
    box-shadow: 0px 3.701px 14.803px 0px rgba(0, 0, 0, 0.26);
    position: fixed;
    bottom: 30px;
    right: ${({ isSecondLanguageOnUrl }) => isSecondLanguageOnUrl ? 'auto' : '30px'};
    left: ${({ isSecondLanguageOnUrl }) => isSecondLanguageOnUrl ? '30px' : 'auto'};
    border-radius: 50px;
    padding: 10px 20px;
    z-index: 10;

    @media (max-width: 768px) {
      right: ${({ isSecondLanguageOnUrl }) => isSecondLanguageOnUrl ? 'auto' : '20px'};
      left: ${({ isSecondLanguageOnUrl }) => isSecondLanguageOnUrl ? '20px' : 'auto'};
      width: fit-content;
    }
  }
`;
